import './App.css'
import { Content } from 'antd/es/layout/layout'
import locales from './locales/locale'
import { memo } from 'react'

export const Elettronica = ({ lang }: { lang: string }) => {
  return (
    <Content style={{ zIndex: 1 }}>
      <div
        style={{ textAlign: 'start' }}
        className="paddingTop paragrafo1 sfondoScuro noPadding "
      >
        <div>
          <h1>{locales.pagina2t1}</h1>
          <p>{locales.pagina2d1}</p>
        </div>
        {/* Photo by Avinash Kumar: https://www.pexels.com/photo/an-external-storage-drive-on-wooden-table-13595074/ */}
        <div className="ssd" />
      </div>
      <div
        style={{ textAlign: 'start' }}
        className="paragrafo1 reverse noPadding"
      >
        <div>
          <h1>{locales.pagina2t2}</h1>
          <p>{locales.pagina2d2}</p>
        </div>
        {/* Photo by Athena Sandrini: https://www.pexels.com/photo/two-white-hyperx-ram-stick-2582928/ */}
        <div className="ram" />
      </div>
    </Content>
  )
}

export default memo(Elettronica)
